import { ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import { paymentNotice } from "@/lib/payment-notice";

/** Aviso visible antes de pagar: MMEXICO en recibo, LADYGUIA en estado de cuenta. */
export function PaymentBrandNotice({ className = "" }: { className?: string }) {
  const { i18n } = useTranslation();
  return (
    <p
      data-testid="payment-brand-notice"
      className={`flex gap-2 rounded-md border border-border bg-muted/50 p-3 text-xs leading-relaxed text-muted-foreground ${className}`}
    >
      <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden />
      <span>{paymentNotice(i18n.language)}</span>
    </p>
  );
}
